/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateMigrationJobRequest,
  CreateMigrationJobResponse,
  LegacyAuthRequest,
  LegacyAuthResponse,
  MigrationJobListResponse,
  MigrationJobResponse
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Authenticate with legacy Space Invoices credentials and get a list of owned organizations.
 * @summary Authenticate with legacy API
 */
export type legacyMigrationAuthResponse200 = {
  data: LegacyAuthResponse
  status: 200
}

export type legacyMigrationAuthResponse401 = {
  data: void
  status: 401
}

export type legacyMigrationAuthResponseSuccess = (legacyMigrationAuthResponse200) & {
  headers: Headers;
};
export type legacyMigrationAuthResponseError = (legacyMigrationAuthResponse401) & {
  headers: Headers;
};

export type legacyMigrationAuthResponse = (legacyMigrationAuthResponseSuccess | legacyMigrationAuthResponseError)

export const getLegacyMigrationAuthUrl = () => {


  

  return `/legacy-migration/auth`
}

export const legacyMigrationAuth = async (legacyAuthRequest: LegacyAuthRequest, options?: RequestInit): Promise<legacyMigrationAuthResponse> => {
  
  return customFetch<legacyMigrationAuthResponse>(getLegacyMigrationAuthUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      legacyAuthRequest,)
  }
);}
  

/**
 * Create a new legacy migration job.
 * @summary Create migration job
 */
export type createMigrationJobResponse202 = {
  data: CreateMigrationJobResponse
  status: 202
}

export type createMigrationJobResponse409 = {
  data: void
  status: 409
}

export type createMigrationJobResponseSuccess = (createMigrationJobResponse202) & {
  headers: Headers;
};
export type createMigrationJobResponseError = (createMigrationJobResponse409) & {
  headers: Headers;
};

export type createMigrationJobResponse = (createMigrationJobResponseSuccess | createMigrationJobResponseError)

export const getCreateMigrationJobUrl = () => {


  

  return `/legacy-migration/jobs`
}

export const createMigrationJob = async (createMigrationJobRequest: CreateMigrationJobRequest, options?: RequestInit): Promise<createMigrationJobResponse> => {
  
  return customFetch<createMigrationJobResponse>(getCreateMigrationJobUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createMigrationJobRequest,)
  }
);}
  

/**
 * List all migration jobs for the current account.
 * @summary List migration jobs
 */
export type listMigrationJobsResponse200 = {
  data: MigrationJobListResponse
  status: 200
}

export type listMigrationJobsResponseSuccess = (listMigrationJobsResponse200) & {
  headers: Headers;
};
;

export type listMigrationJobsResponse = (listMigrationJobsResponseSuccess)

export const getListMigrationJobsUrl = () => {


  

  return `/legacy-migration/jobs`
}

export const listMigrationJobs = async ( options?: RequestInit): Promise<listMigrationJobsResponse> => {
  
  return customFetch<listMigrationJobsResponse>(getListMigrationJobsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get status and progress of a migration job.
 * @summary Get migration job status
 */
export type getMigrationJobResponse200 = {
  data: MigrationJobResponse
  status: 200
}

export type getMigrationJobResponse404 = {
  data: void
  status: 404
}

export type getMigrationJobResponseSuccess = (getMigrationJobResponse200) & {
  headers: Headers;
};
export type getMigrationJobResponseError = (getMigrationJobResponse404) & {
  headers: Headers;
};

export type getMigrationJobResponse = (getMigrationJobResponseSuccess | getMigrationJobResponseError)

export const getGetMigrationJobUrl = (id: string,) => {


  

  return `/legacy-migration/jobs/${id}`
}

export const getMigrationJob = async (id: string, options?: RequestInit): Promise<getMigrationJobResponse> => {
  
  return customFetch<getMigrationJobResponse>(getGetMigrationJobUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

